module.exports = __webpack_public_path__ + "img/Group 81_white.673e2faf.svg";